const team = [
  {
    name: 'Cihan Tutum',
    title: 'CEO & Founding Partner',
    bio: 'Over 15 years of experience in the game industry. Expert in studio management, business development, and strategic planning.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20man%20in%20his%20late%2030s%20with%20dark%20hair%20and%20a%20confident%20warm%20expression%2C%20wearing%20a%20casual%20dark%20blazer%20over%20a%20t-shirt%2C%20modern%20minimal%20studio%20portrait%20with%20warm%20amber%20backdrop%20lighting%2C%20clean%20background%2C%20professional%20but%20approachable%20look%2C%20gaming%20industry%20creative%20professional&width=600&height=600&seq=coreloop-team-cihan&orientation=squarish',
    socials: { linkedin: '#', twitter: '#' },
  },
  {
    name: 'Onur Can Çaylı',
    title: 'Founding Partner & Creative Director',
    bio: 'Art director of award-winning games. 12 years of experience in visual storytelling, art style development, and leading creative teams.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20man%20in%20his%20mid%2030s%20with%20a%20thoughtful%20creative%20expression%2C%20wearing%20a%20dark%20casual%20shirt%2C%20modern%20minimal%20studio%20portrait%20with%20warm%20teal%20backdrop%20lighting%2C%20clean%20background%2C%20artistic%20and%20creative%20professional%20vibe%2C%20gaming%20industry%20creative%20director&width=600&height=600&seq=coreloop-team-onur&orientation=squarish',
    socials: { linkedin: '#', twitter: '#' },
  },
  {
    name: 'Altuğ Işığan',
    title: 'Partner & Game Designer',
    bio: 'Deep expertise in systems design, player psychology, and game balance. Over 10 years shaping the design of hit games across multiple platforms.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20man%20in%20his%20early%2030s%20with%20an%20analytical%20yet%20friendly%20expression%2C%20wearing%20a%20dark%20hoodie%20under%20a%20casual%20jacket%2C%20modern%20minimal%20studio%20portrait%20with%20warm%20amber%20backdrop%20lighting%2C%20clean%20background%2C%20game%20designer%20professional%20look%2C%20creative%20tech%20industry&width=600&height=600&seq=coreloop-team-altug&orientation=squarish',
    socials: { linkedin: '#', twitter: '#' },
  },
];

export default function TeamSection() {
  return (
    <section id="team" className="relative py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-primary-600 mb-3">Our Team</span>
          <h2 className="text-3xl md:text-5xl font-bold font-heading text-foreground-950 mb-4">
            Expert Team
          </h2>
          <p className="text-base text-foreground-600 max-w-xl mx-auto">
            Three partners with deep expertise across different areas of the game industry, ready to support your studio.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {team.map((member) => (
            <div
              key={member.name}
              className="group relative bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden transition-all duration-500 hover:border-primary-200/60"
            >
              <div className="relative h-72 overflow-hidden">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              </div>

              <div className="p-6 text-center">
                <h3 className="text-xl font-bold font-heading text-foreground-900 mb-1">{member.name}</h3>
                <p className="text-sm font-medium text-primary-600 mb-3">{member.title}</p>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">{member.bio}</p>
                <div className="flex items-center justify-center gap-3">
                  <a href={member.socials.linkedin} className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-100 text-foreground-500 hover:text-primary-500 hover:bg-primary-50 transition-all duration-300 cursor-pointer" aria-label="LinkedIn">
                    <i className="ri-linkedin-fill text-lg"></i>
                  </a>
                  <a href={member.socials.twitter} className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-100 text-foreground-500 hover:text-primary-500 hover:bg-primary-50 transition-all duration-300 cursor-pointer" aria-label="Twitter">
                    <i className="ri-twitter-x-line text-lg"></i>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}